import { render } from "./AnswerPage.vue?vue&type=template&id=17959814&scoped=true"
import script from "./AnswerPage.vue?vue&type=script&lang=js"
export * from "./AnswerPage.vue?vue&type=script&lang=js"

import "./AnswerPage.vue?vue&type=style&index=0&id=17959814&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17959814"]])

export default __exports__